import axios from 'axios'
import { InvoiceMultiPageSetting } from '../interfaces/Invoices'

const API_URL = process.env.REACT_APP_API_URL

const Invoices = `${API_URL}invoices/settings/`
const InvoicesGenerated = `${API_URL}invoices/generated/list/`
const InvoicesAddLog = `${API_URL}invoices/generated/latest/`
const InvoicesSendWhastApp = `${API_URL}invoices/generated/send/`
const MaspionInvoiceRegenerate = `${API_URL}custom/maspion/invoices/sewa-permanen/termin/regenerate`

export const getInvoices = (token: string, progressId?: string) => {
  return axios.get(Invoices, {
    headers: {
      'X-Auth-token': token,
    },
    params: {
      progressId,
    },
  })
}

export const getInvoiceGenerated = (token: string, leadId?: string, progressId?: string) => {
  return axios.get(InvoicesGenerated, {
    headers: {
      'X-Auth-token': token,
    },
    params: {
      leadId,
      progressId,
    },
  })
}


export const getInvoiceById = (token: string, id: string) => {
  return axios.get(Invoices+id, {
    headers: {
      'X-Auth-token': token,
    },
  })
}

export const getInvoiceGeneratedById = (token: string, id: string) => {
  return axios.get(InvoicesGenerated+id, {
    headers: {
      'X-Auth-token': token,
    },
  })
}

export const getInvoiceGeneratedByLatest = (token: string, progressId: string, leadId: string) => { //: Promise<InvoiceMultiPageSetting>
  return axios.get(InvoicesAddLog, {
    headers: {
      'X-Auth-token': token,
    },
    params: {
      progressId,
      leadId
    },
  })
}

export const sendFileInvoiceGenerated = (token: string, invoiceId:string, file: string|File) => {
  const formData = new FormData()
  formData.append('invoiceId', invoiceId)
  formData.append('file', file)

  return axios.post(InvoicesSendWhastApp, formData, {
    headers: {
      'X-Auth-token': token,
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const insertInvoices = (data: any, token: string) => {
  return axios.post(Invoices, data, {
    headers: {
      'X-Auth-token': token,
    },
  })
}

export const updateInvoices = (id: string, data: any, token: string) => {
  return axios.put(Invoices + id, data, {
    headers: {
      'X-Auth-token': token,
    },
  })
}

export const deleteInvoices = (id: string, token: string) => {
  return axios.delete(Invoices + id, {
    headers: {
      'X-Auth-token': token,
    },
  })
}

export const regenerateInvoiceMaspion = (token: string) => {
  return axios.post(MaspionInvoiceRegenerate, 
    {}, 
    {
      headers: {
        'X-Auth-token': token, 
      },
    }
  )
}